<template>
  <div class="form-container">
    <div
      v-if="permissionFilter.includes(profile.roles.name)"
      class="mb-3 d-flex justify-content-end align-items-center"
    >
      <div class="filter">
        <b-row>
          <b-col>
            <b-form-group
              label="Company"
              label-size="sm"
              content-cols-sm="8"
              label-for="input-horizontal"
              label-class="font-weight-bold"
            >
              <b-form-select
                v-model="company"
                :options="companyOptions"
                placeholder="Select Company"
                value-field="id"
                text-field="name"
                size="sm"
                @change="$refs.summaryProgress.refresh()"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                  >
                    All Company
                  </b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <filters
      :filter-data.sync="filters"
      @apply="$refs.summaryProgress.refresh()"
      @reset="resetFilter"
    />
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div v-if="!visible">
        List Summary Progress
      </div>
      <div class="menu-selected d-flex justify-content-between" v-if="visible">
        <div class="text-selected">{{ selectedItems.length }} Selected</div>
        <b-button
          v-if="!haveApproved"
          class="btn-custom"
          variant="success"
          size="sm"
          @click="onSelectedSubmit(selectedItems)"
        >
          Submit
        </b-button>
        <b-button
          class="btn-custom ml-2"
          variant="success"
          size="sm"
          @click="onSelectedPrint(selectedItems)"
        >
          Print
        </b-button>
      </div>
      <div>
        <span>Show</span>
        <b-form-select
          v-model="perPage"
          :options="perPageOptions"
          class="page-option ml-2 mr-2 w-auto"
        />
        <span>Entries</span>
      </div>
      <b-form-group class="m-0">
        <b-form-input
          v-model="search"
          placeholder="Search..."
          @change="$refs.summaryProgress.refresh()"
          size="sm"
        ></b-form-input>
      </b-form-group>
    </div>
    <b-table
      hover
      class="mb-4"
      table-class="table-summary-progress"
      thead-class="table-list-header"
      empty-text="No data"
      ref="summaryProgress"
      :items="fetchSummaryProgress"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      @row-clicked="goDetail"
      sort-icon-left
      show-empty
      responsive
    >
      <template v-slot:table-busy>
        <div class="text-center my-4">
          <b-spinner variant="info" class="spinner-lg" />
        </div>
      </template>
      <template v-slot:cell(selected)="items">
        <div class="h-100 py-2 px-3" @click.stop>
          <b-form-checkbox
            v-if="canAdd || canPrint"
            @input="onPreviewClick($event, items.item)"
            size="lg"
          />
        </div>
      </template>
      <template v-slot:cell(Action)="items" v-if="canPrint || canAdd">
        <div>
          <b-dropdown
            toggle-class="text-dark p-0"
            menu-class="shadow border-0"
            variant="link"
            right
            no-caret
          >
            <template v-slot:button-content>
              <fa-icon class="text-info" icon="ellipsis-v" />
            </template>
            <b-dropdown-item
              v-if="canPrint"
              @click="onPrint(items.item)"
            >
              Print
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canAdd && (items.item.status === 'Draft' || items.item.status === 'Revise')"
              @click="onRowSubmit(items.item)"
            >
              Submit
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template #cell()="{ value, item }">
        <a
          class="d-block h-100 text-dark"
          :href="`/summary-progress/detail?${item.sp_id ? `sp_id=${item.sp_id}` : `wo_id=${item.wo_id}`}`"
        >
          {{ value }}
        </a>
      </template>
      <template v-slot:cell(payment_period)="{ item }">
        <a
          class="d-block text-dark"
          :href="`/summary-progress/detail?${item.sp_id ? `sp_id=${item.sp_id}` : `wo_id=${item.wo_id}`}`"
        >
          {{ item.validity_periode_start + ' - ' + item.validity_periode_end }}
        </a>
      </template>
      <template #cell(status)="items">
        <div :class="statusChange(items.item.status)">{{ items.item.status }}</div>
      </template>
      <template #cell(progress)="items">
        <div class="percentage">
          <b-progress>
            <b-progress-bar v-model="items.item.progress"></b-progress-bar>
          </b-progress>
          <div class="label-progress">  {{ `${parseInt(items.item.progress)}%` }} </div>
        </div>
      </template>
    </b-table>
    <div class="d-flex justify-content-end align-items-center">
      <span class="show-entries mr-auto ml-4">
        {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
      </span>
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="totalRows"
        pills
        hide-goto-end-buttons
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Filters from './Filter'
import { hasPermission } from '@/utils/permissions'
import { SUMMARY_PROGRESS_ADD, SUMMARY_PROGRESS_PRINT } from '@/fixtures'

export default {
  components: {
    Filters
  },

  data: () => ({
    profile: JSON.parse(localStorage.getItem('profile')),
    canAdd: hasPermission(SUMMARY_PROGRESS_ADD),
    canPrint: hasPermission(SUMMARY_PROGRESS_PRINT),
    visible: false,
    isBusy: false,
    search: '',
    currentPage: localStorage.getItem('currentPage') ?? 1,
    perPage: 10,
    totalRows: localStorage.getItem('totalRows') ?? 0,
    sortBy: 'contractor_name',
    sortDesc: false,
    fields: [
      { key: 'selected', label: '', sortable: false, thClass: 'start', tdClass: 'p-0' },
      { key: 'Action', sortable: false },
      { key: 'contractor_name', label: 'Contractor Name', thStyle: 'width: 150px', sortable: true },
      { key: 'contract_number', label: 'Contract Number', sortable: true },
      { key: 'payment_period', thStyle: 'width: 200px', sortable: false },
      { key: 'wo_number', label: 'WO Number', sortable: true },
      { key: 'budget_code', label: 'Budget Code', sortable: true, thStyle: 'width: 200px' },
      { key: 'job_desc', label: 'Job Desc', sortable: true, thStyle: 'width: 200px' },
      { key: 'department', label: 'Department', sortable: true },
      { key: 'status', thStyle: 'width: 150px', sortable: true },
      { key: 'progress', sortable: true, thClass: 'end' }
    ],
    items: [],
    perPageOptions: [
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 30, text: '30' }
    ],
    valueOptions: [],
    filters: !localStorage.getItem('filterSummaryProgress') ? {
      contractor_name: '',
      contract_number: '',
      payment_period: '',
      wo_number: '',
      department: '',
      job_desc: '',
      budget_code: '',
      status: ''
    } : JSON.parse(localStorage.getItem('filterSummaryProgress')),
    selectedItems: [],
    haveApproved: false,
    company: null,
    companyOptions: [],
    permissionFilter: [
      'Super Admin',
      'Finance Jakarta',
      'Administrator'
    ]
  }),

  computed: {
    stringifiedFilters() {
      const str = Object.entries(this.filters).filter(v => v[1]).map(v => v.join(':')).join()
      return str
    }
  },

  mounted() {
    this.fetchCompany()
  },

  methods: {
    async fetchSummaryProgress() {
      const data = await api.summaryProgress.list({
        sort_by: this.sortBy,
        sort_dir: this.sortDesc ? 'desc' : 'asc',
        page: this.currentPage,
        limit: this.perPage,
        search: this.search,
        company_id: this.company,
        filter_value: this.stringifiedFilters
      })
      this.totalRows = data ? data.count : 100
      this.items = data ? data.rows : []
      this.items.map(d => {
        if (!d.has_summary && d.status === 'Approved') {
          d._rowVariant = 'success'
        }
      })

      localStorage.removeItem('currentPage')
      localStorage.removeItem('totalRows')

      localStorage.setItem('filterSummaryProgress', JSON.stringify(this.filters))

      this.selectedItems = this.$options.data().selectedItems
      this.visible = false

      return this.items
    },
    resetFilter() {
      this.filters = {
        contractor_name: '',
        contract_number: '',
        payment_period: '',
        wo_number: '',
        department: '',
        job_desc: '',
        budget_code: '',
        status: ''
      }
      this.currentPage = 1
      localStorage.removeItem('filterSummaryProgress')
      this.$refs.summaryProgress.refresh()
    },
    async fetchCompany() {
      try {
        this.companyOptions = await api.company.list_active()
      } catch ({ response }) {
        this.error = response.data.message
      }
    },
    goDetail(item) {
      localStorage.setItem('currentPage', this.currentPage)
      localStorage.setItem('totalRows', this.totalRows)
      this.$router.push({ path: `/summary-progress/detail?${item.sp_id ? `sp_id=${item.sp_id}` : `wo_id=${item.wo_id}`}` })
    },
    statusChange(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Approved') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    },
    onPreviewClick(value, item) {
      if (value) {
        this.selectedItems.push(item)
        this.haveApproved = this.selectedItems.find(d => d.status === 'Approved')
      } else {
        if (this.selectedItems.length !== 1) {
          const index = this.selectedItems.findIndex(d => d.id === item.id)
          this.selectedItems = [
            ...this.selectedItems.slice(0, index),
            ...this.selectedItems.slice(index + 1)
          ]
          this.haveApproved = this.selectedItems.some(d => d.status === 'Approved')
        } else {
          this.selectedItems = []
        }
      }
      this.visible = this.selectedItems.length !== 0
    },
    async onSelectedPrint(item) {
      item.forEach(d => {
        this.onPrint(d)
      })
    },
    async onSelectedSubmit(item) {
      item.forEach(d => {
        this.onRowSubmit(d)
      })
      this.$refs.summaryProgress.refresh()
    },
    async onPrint(item) {
      const url = `${process.env.VUE_APP_PRINT_URL}/SummaryProgress?WoId=${item.wo_id}&SpId=${item.sp_id ?? 0}`
      window.open(url)
    },
    async onRowSubmit(item) {
      try {
        await api.summaryProgress.submit({
          hm_ewh_id: item.id,
          wo_id: item.wo_id,
          company_id: item.company_id
        })
        this.$bvModal.show('modal-successful')
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
}
.text-selected {
  margin-right: 10px;
  font-size: 18px;
  font-weight: 600;
  margin-top: 2px;
}
.label-progress {
  color: #1A051D;
  font-size: 12px;
  line-height: 14px;
  text-align: right;
  margin-left: 15px;
}

.progress-bar {
  background-color: #00B4A5;
  border-radius: 6px;
  width: 90px;
  height: 12px;
}

.progress {
  background-color: #EAE7F3;
  border-radius: 6px;
  width: 100px;
  height: 12px;
  flex: 1 0 auto;
}

.percentage {
  display: flex
}
</style>
